package br.com.texeratx.boardgametimeapp.ui.spotifydevices

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.RadioButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import br.com.texeratx.boardgametimeapp.core.i18n.LocalStrings

@Composable
fun SpotifyDevicePicker(
    state: SpotifyDevicesUiState,
    onRefresh: () -> Unit,
    onSelect: (String?) -> Unit,
    enabled: Boolean = true,
    disabledMessage: String? = null,
) {
    val S = LocalStrings.current
    Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                S.spotifyDeviceTitle,
                style = MaterialTheme.typography.titleMedium
            )
            Spacer(Modifier.weight(1f))
            Button(onClick = onRefresh, enabled = enabled && !state.isLoading) {
                Text(S.spotifyRefresh)
            }
        }

        if (!enabled) {
            if (!disabledMessage.isNullOrBlank()) {
                Text(disabledMessage)
            }
            return
        }

        if (state.isLoading) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.Center
            ) {
                CircularProgressIndicator()
            }
            return
        }

        Card(
            modifier = Modifier
                .fillMaxWidth()
                .clickable { onSelect(null) }
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .heightIn(min = 44.dp)
                    .padding(horizontal = 10.dp, vertical = 6.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                RadioButton(
                    selected = state.selectedDeviceId == null,
                    onClick = { onSelect(null) }
                )
                Column {
                    Text(S.spotifyDoNotPlay)
                }
            }
        }

        state.error?.let { msg ->
            Text(msg, color = MaterialTheme.colorScheme.error)
        }

        if (state.devices.isEmpty()) {
            Text(S.spotifyNoDevices)
            return
        }

        state.devices.forEach { device ->
            val id = device.id
            val enabled = id != null && !device.isRestricted
            val selected = id != null && id == state.selectedDeviceId

            Card(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable(enabled = enabled && id != null) { onSelect(id!!) }
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .heightIn(min = 44.dp)
                        .padding(horizontal = 10.dp, vertical = 6.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    RadioButton(
                        selected = selected,
                        onClick = { if (enabled && id != null) onSelect(id) },
                        enabled = enabled
                    )

                    Spacer(Modifier.height(0.dp))

                    Column {
                        Text(device.name)
                        Text(
                            buildString {
                                append(device.type)
                                if (device.isActive) append(S.spotifyDeviceActive)
                                if (device.isRestricted) append(S.spotifyDeviceRestricted)
                            },
                            style = MaterialTheme.typography.bodySmall
                        )
                    }
                }
            }
        }
    }
}
